module.exports = __webpack_public_path__ + "media/markers/marker-indigo-c54bedd1.svg";